import { GlobalController } from 'src/shared/global/GlobalController'
import Cadri from './Cadri'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'cadri',
    component: Cadri,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
